import { AppUser, TOrgTag } from '@eventr/common'
import { ColoursObj, Typography } from '@eventr/common-storybook'
import { Box, Checkbox, Stack } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { IOptionsWithTypes } from '../../../state/interfaces'
import { EditTeamMemberLine } from './EditTeamMemberLine'
import {
    checkIfTagSelected,
    checkIfUserSelected,
    filterBySearch,
} from './utils'
interface IDepartmentLineProps {
    tag: TOrgTag
    allUsers: AppUser[]
    membersList: IOptionsWithTypes[]
    userControlBox?: (user: any) => JSX.Element
    onAddDepartment: (tag: string) => void
    onRemoveDepartment: (tag: string) => void
    onRemoveUser: (user: AppUser) => void
    onAddUser: (user: AppUser) => void
    allowSelfRemove?: boolean
}
export const DepartmentLine = ({
    allUsers,
    tag,
    membersList,
    onAddDepartment,
    onRemoveDepartment,
    onRemoveUser,
    onAddUser,
    userControlBox,
    allowSelfRemove,
}: IDepartmentLineProps) => {
    const tagUsers = allUsers.filter((user) => {
        return user.departmentTags.includes(tag.name)
    })

    const allSelected = tagUsers.every((user) => {
        return checkIfUserSelected(user.id, membersList)
    })

    const allDeselected = useMemo(
        () =>
            tagUsers.every((user) => {
                return !checkIfUserSelected(user.id, membersList)
            }),
        [tagUsers, membersList]
    )
    const inItinerary = useMemo(
        () =>
            checkIfTagSelected(tag.name, membersList, [
                'Department',
                'DepartmentV2',
            ]),
        [membersList, tag.name]
    )
    useEffect(() => {
        if (allDeselected && inItinerary) {
            onRemoveDepartment(tag.name)
        }
    }, [inItinerary, allDeselected, tag.name, onRemoveDepartment])
    return (
        <Stack width="100%" key={tag.name} gap={'8px'}>
            {tagUsers &&
                tagUsers.length > 0 &&
                filterBySearch(tagUsers).length > 0 && (
                    <>
                        <div
                            key={tag.name}
                            style={{
                                display: 'grid',
                                gridTemplateColumns: 'auto 1fr auto',
                                alignItems: 'center',
                                width: '100%',
                                gap: '8px',
                                backgroundColor:
                                    ColoursObj.backgrounds.secondary,
                                borderRadius: '8px',
                            }}
                            onClick={() => {
                                if (inItinerary || allSelected) {
                                    onRemoveDepartment(tag.name)
                                } else {
                                    onAddDepartment(tag.name)
                                }
                            }}
                        >
                            <Box>
                                <Checkbox
                                    id={`edit-members-department-checkbox-${tag.name}`}
                                    indeterminate={inItinerary && !allSelected}
                                    checked={allSelected}
                                    sx={{ color: ColoursObj.core.primary }}
                                />
                            </Box>

                            <Box>
                                <Typography variant="bodyBold">
                                    {tag.name}
                                </Typography>
                            </Box>

                            <Box
                                sx={{
                                    margin: '8px',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    background: ColoursObj.backgrounds.card,
                                }}
                            >
                                <Typography variant="bodyRegular">
                                    {tagUsers.length ?? '0'}
                                </Typography>
                            </Box>
                        </div>
                        <Stack padding={'0px 0px 0px 8px'}>
                            {filterBySearch(tagUsers).map((orgUser, i) => {
                                return (
                                    <EditTeamMemberLine
                                        id="department-checkbox-"
                                        key={i}
                                        user={orgUser}
                                        onAdd={onAddUser}
                                        onRemove={(u) => onRemoveUser(u)}
                                        allowSelfRemove={allowSelfRemove}
                                        membersList={membersList}
                                        userControlBox={userControlBox}
                                    />
                                )
                            })}
                        </Stack>
                    </>
                )}
        </Stack>
    )
}
